import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ViewFeedbackAnswerComponent from '../components/viewFeedbackAnswerComponent';
import { getFeedbackAnswerListFunc,getUpdatedAlarmStatusFunc } from '../actions/viewFeedbackAnswerAction';

class ViewFeedbackAnswerContainer extends Component {
    
    componentDidMount() {
            this.props.actions.getFeedbackAnswerListFunc(
            this.props.dispatch)
    }
   getAlarmReceiverListData = (payload) => {
          this.props.actions.getUpdatedAlarmStatusFunc(
              payload,
              this.props.dispatch
          )
      }  
    render() {
        return (
            <div className="agile-grids">
                <div className="grids">
                    <div className="container">
                        <div className="row"> 
                            <ViewFeedbackAnswerComponent
                                feedbackAnswerList={this.props.feedbackAnswerList}
                                getAlarmReceiverListData={this.getAlarmReceiverListData}
                            />
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch: dispatch,
        actions: bindActionCreators({
            getFeedbackAnswerListFunc,
            getUpdatedAlarmStatusFunc,
        }, dispatch)
    };
};

function mapStateToProps({ viewFeedbackAnswerReducer}) {
    console.log(viewFeedbackAnswerReducer);
    return {
        feedbackAnswerList: {
            isLoading: viewFeedbackAnswerReducer.isLoading,
            answerList: viewFeedbackAnswerReducer.answerList,
            errorCode: viewFeedbackAnswerReducer.errorCode,
            messageLabel: viewFeedbackAnswerReducer.messageLabel,  
            alarmReceiverList:viewFeedbackAnswerReducer.alarmReceiverList,  
            statusCode: viewFeedbackAnswerReducer.statusCode
        },
        
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ViewFeedbackAnswerContainer))